import styled from 'styled-components';

export const TableRow = styled.div`
  display: flex;
  justify-content: space-between;

  &:first-of-type {
    margin-block: 0.75rem;
  }

  &:not(:first-of-type) {
    margin-block-end: 0.75rem;
  }
`;

export const Label = styled.span``;

export const TableHeader = styled.h5<{
  $isBKBrand?: boolean;
}>`
  margin-block-start: 1.5rem;
  margin-block-end: 1rem;
  margin-inline: 0;
  width: 100%;
  font-size: 1rem;
  font-weight: ${Styles.fontWeight.heavy};
  border-block-end: ${props => {
    const color = props?.$isBKBrand ? Styles.color.grey.five : Styles.color.grey.four;
    return `1px solid ${color}`;
  }};
`;

export const IconList = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 0.25rem;
`;

export const IconListIcon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
